import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let homeAnimationIsComplete = false;
const contentAreaEl = document.querySelector('.content-area');
const contentPanelReveal = document.querySelector('.content-panel-reveal');

featherify.on('mounted', () => {
    if (homeAnimationIsComplete) {
        document.body.classList.add('complete');
    }

    contentAreaEl.style.opacity = 1;

    const homePanels = document.querySelector('body.home .panels');

    if (homePanels && ! homeAnimationIsComplete) {
        contentPanelReveal.style.display = 'none';

        const homeTimeline = gsap.timeline({
            delay: 0.75,
        });

        const introWordSplit = new SplitText('.home-intro-text', {
            type: 'words, chars',
            wordsClass: 'word-wrap'
        });

        let homeIntroTexts = document.querySelectorAll('.home-intro-text');

        homeIntroTexts.forEach(homeIntroText => {
            homeIntroText.classList.add('loading');
        });

        homeTimeline.to('.hero-overlay', {
            opacity: 1,
            duration: 0.4,
        })
        .to('.header', {
            top: 0,
            duration: 1,
            ease: 'power4.inOut',
        }, '>0.25')
        .to(homePanels,  {
            opacity: 1,
            translateY: 0,
            duration: 1,
            ease: 'power4.inOut',
            onComplete() {
                homeAnimationIsComplete = true;
                document.querySelector('body').classList.add('complete');
            },
        }, '<')
        .to('.footer', {
            opacity: 1,
            duration: 0,
        })
        .fromTo(introWordSplit.chars, {
            translateY: '100%',
        }, {
            translateY: 0,
            duration: 0.4,
            onComplete() {
                introWordSplit.revert();

                setTimeout(() => {
                    homeIntroTexts.forEach(homeIntroText => {
                        homeIntroText.classList.remove('loading');
                    });

                    document.querySelectorAll('.home-intro-text a').forEach(homeIntroTextLink => {
                        delete homeIntroTextLink.dataset.featherified;
                    });

                    featherify.listen();
                }, 10);
            },
        }, '<');
    }

    if (! homePanels || homeAnimationIsComplete) {
        if (window.location.hash) {
            const scrollToEl = document.querySelector(window.location.hash);

            if (scrollToEl) {
                setTimeout(() => {
                    scrollToEl.scrollIntoView({
                        behavior: 'smooth',
                    });
                }, 10);
            }
        }

        gsap.fromTo(contentPanelReveal, {
            display: 'block',
            translateY: 0,
        }, {
            display: 'block',
            translateY: '-100%',
            duration: 0.5,
            ease: 'power1.inOut',
        });
    }

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', e => {
            e.preventDefault();

            const scrollToEl = document.querySelector(anchor.getAttribute('href'));

            if (scrollToEl) {
                scrollToEl.scrollIntoView({
                    behavior: 'smooth',
                });

                history.pushState({}, '', anchor.href);
            }
        });
    });
})();

featherify.on('beforeUnmountAnimation', () => {
    featherify.animate(animated => {
        let hamburgerEl = document.querySelector('.hamburger');

        if (hamburgerEl.classList.contains('active')) {
            let headerEl = document.querySelector('.header');
            let mobileNavEl = document.querySelector('.mobile-nav');

            headerEl.classList.remove('active');
            hamburgerEl.classList.remove('active');
            mobileNavEl.classList.remove('open');

            gsap.set(contentAreaEl, {
                opacity: 0,
                onComplete() {
                    animated();
                },
            });

            return;
        }

        gsap.to(contentAreaEl, {
            opacity: 0,
            duration: 0.25,
            onComplete() {
                animated();
            },
        });
    });
});
